import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import api from '../../services/api.service'
import { messageActions } from '../../store/message'
import storage from '../../services/stoage.service'
import utils from '../../utils/index'
import { mensagensDeErro } from '../../utils/credencialMascarada'
const BASE_PATH = '/lottustech/configuracaounidade'
const prefix = 'crudParametro'
const crud = build(validate, BASE_PATH)

const mensagensErro = (err) =>
  mensagensDeErro(
    err,
    utils.getMessage(storage.getAppLabels('parametrosunidade'), 'parametrosunidade.label.falhaComunicacao')
  )

const newTypes = {
  RESET: `${prefix}reset`,
}

const actions = new Action(prefix, crud)

const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.loadKeys = (oidUnidade) => {
  return (dispatch, getState) => {
    const state = getState()[`crudParametroState`]
    actions.setDefaultColumns(state)
    api
      .get(`${BASE_PATH}/${oidUnidade}/allKeys`)
      .then(({ data }) => {
        dispatch(actions.fetchRecordsSuccess(data))
      })
      .catch((err) => {
        dispatch(actions.fetchRecordsError(err))
      })
  }
}

// recarregar = false: quem chama recarrega depois (renomear); a falha recarrega sempre.
actions.updateKey = (oidUnidade, key, value, recarregar = true) => {
  return (dispatch) => {
    dispatch(actions.clearErrors())
    if (key) {
      // Devolve se gravou, para quem precisa encadear (renomear so apaga a chave antiga depois de gravar a nova).
      return api
        .post(`${BASE_PATH}/${oidUnidade}/updateKey`, {
          id: key,
          value: value,
        })
        .then((response) => {
          if (recarregar && actions.afterSave) {
            actions.afterSave()
          }
          return true
        })
        .catch((err) => {
          dispatch(messageActions.showMessages(mensagensErro(err), 'error'))
          // Recarrega para mostrar o que ficou gravado.
          if (actions.afterSave) {
            actions.afterSave()
          }
          return false
        })
    }
    return Promise.resolve(false)
  }
}

// Devolve se removeu. Falha mostra a mensagem e recarrega (a tela tira a linha da grade ao remover).
actions.deleteKey = (oidUnidade, key) => {
  return (dispatch) => {
    dispatch(actions.clearErrors())
    if (!key) {
      return Promise.resolve(false)
    }
    // Nome codificado: sem isso o navegador corta espaco no fim e trata ?, # e % como parte da URL - e o DELETE
    // apagava OUTRA chave (renomear "tokenAutentique " para "tokenAutentique" apagava a recem-gravada).
    return api
      .remove(`${BASE_PATH}/${oidUnidade}/deleteKey/${encodeURIComponent(key)}`)
      .then(() => true)
      .catch((err) => {
        dispatch(messageActions.showMessages(mensagensErro(err), 'error'))
        if (actions.afterSave) {
          actions.afterSave()
        }
        return false
      })
  }
}

export { types, actions }
